export default __webpack_public_path__ + "static/media/ellipse13534366-h1ms.d6d7cbed.svg";